import { useMemo } from 'react';
import { useMeQuery, useWorkspaceRecordsQuery } from '@platform/state/api';
import { useLabel } from '@platform/hooks/useLabel';
import { navGroup } from '@platform/navigation';
import { todayIso } from '@platform/core/lib/format';
import { addDays } from '../work/homeViews';
import { mainRecordTypes } from '../../shell/mainRecordTypes';
import { useModuleDescriptions } from '../../shell/strings/useModuleDescriptions';
import { useWorkspaceCatalog } from '../../shell/useWorkspaceCatalog';
import { areaModules } from './areaModules';
import { areaStats } from './areaStats';
import type { IAreaView } from './IAreaView';

/** Огляд напряму робочого простору: модулі групи верхнього меню й зведення за записами їхніх головних таблиць (один запит на тип, кешується). */
export function useAreaStats(ws: string, groupKey: string): IAreaView {
  const label = useLabel();
  const { data: me } = useMeQuery();
  const { catalog, parliament } = useWorkspaceCatalog(ws);
  const describe = useModuleDescriptions(catalog, navGroup(groupKey)?.modules ?? []);
  const modules = useMemo(() => areaModules(catalog, groupKey, label, describe, parliament), [catalog, groupKey, label, describe, parliament]);
  const types = mainRecordTypes(catalog, modules.map((m) => m.key));
  const { data } = useWorkspaceRecordsQuery({ ws, types }, { skip: !catalog || !types.length });
  const stats = useMemo(() => {
    if (!catalog || (types.length && !data)) return undefined;
    const today = todayIso();
    return areaStats(data?.items ?? [], modules, me?.id, today, addDays(today, 7), Date.now());
  }, [catalog, data, modules, me?.id, types.length]);
  return { modules, stats };
}
